import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';
import ArrowForward from '@mui/icons-material/ArrowForward';

import PrimaryCTA from '../../../../../components/Atoms/PrimaryCTA/PrimaryCTA';
import findDomElement from '../../../../findDomElement';
import { testAttributes, qlctabuttonlinkClass } from './Constants';

const toPrimaryCTA = (parsed) => 
{
    const {
        articleId,
        parserOptions: { replaceFn },
    } = parsed;

    const Wrapper = ({ name = '', type = '', attribs = { href: '' }, children = null }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'a') return null;
        if (children?.length === 0) return null;
        if (!attribs?.href) return null;
        if (!attribs?.class || !attribs?.class.includes(qlctabuttonlinkClass))
            return null;
        const classNames = attribs.class.split(' ');

        const props = { href: '', buttonText: '', buttonIcon: '' };

        const foundTitle = findDomElement({
            element: children?.filter((child) => child?.type === 'tag').at(0),
            targetName: 'span',
        });

        const foundIconSpan =
            foundTitle?.next &&
            findDomElement({
                element: children
                    ?.filter((child) => child?.type === 'tag')
                    .at(1),
                targetName: 'span',
            });

        const foundSvg =
            foundIconSpan?.children?.length >= 1 &&
            findDomElement({
                element: foundIconSpan?.children
                    ?.filter((child) => child.type === 'tag')
                    ?.at(0),
                targetName: 'svg',
            });

        const foundVariant = classNames.find((c) => c.includes('variant-'));

        const flagNoIconIdentifier =
            foundIconSpan &&
            foundIconSpan?.children?.length === 0 &&
            foundIconSpan?.attribs['data-iconname'] === '.';

        const assignIcon = () => 
        {
            if (foundSvg) return domToReact([foundSvg], replaceFn());
            if (!foundSvg && flagNoIconIdentifier) return null;
            return <ArrowForward />;
        };

        const filteredClassName = classNames.filter( c => (
            c !== qlctabuttonlinkClass
        )).join(' ');

        props.buttonIcon = assignIcon();
        props.href = attribs.href;
        props.buttonText = foundTitle.children?.[0].data;
        props.variant = foundVariant ? foundVariant.split('-').pop() : null;

        if (attribs?.target) 
        {
            props.buttonAttributes = {
                target: attribs.target,
            };
        }

        if (filteredClassName.length)
        {
            props.buttonAttributes = {
                ...props.buttonAttributes,
                className: filteredClassName,
            };
        }

        return (
            <div data-testid={testAttributes.PRIMARY_CTA_CONTAINER}>
                <PrimaryCTA {...props} articleId={articleId} />
            </div>
        );
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['a']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            href: PropTypes.string,
            target: PropTypes.string,
        }),
        buttonAttributes: PropTypes.object,
        children: PropTypes.node,
    };

    return Wrapper;
};

export default toPrimaryCTA;
